import { render } from "./B2bPageCmrEmits.vue?vue&type=template&id=0a1b0f3b&scoped=true&lang=pug"
import script from "./B2bPageCmrEmits.vue?vue&type=script&lang=js"
export * from "./B2bPageCmrEmits.vue?vue&type=script&lang=js"

import "./B2bPageCmrEmits.vue?vue&type=style&index=0&id=0a1b0f3b&lang=scss&scoped=true"
import "./B2bPageCmrEmits.vue?vue&type=style&index=1&id=0a1b0f3b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1b0f3b"]])

export default __exports__